export const SITECORE_MEDIA_PATH = '/-/media';
export const SITECORE_JSS_MEDIA_PATH = '/-/jssmedia';
